<template>
  <div class="markingStyle">
    <div class="item">
      <div class="title">标记方式</div>
      <el-radio-group v-model="radio">
        <el-radio label="font">文字颜色</el-radio>
        <el-radio label="background">背景颜色</el-radio>
      </el-radio-group>
    </div>
    <div class="item">
      <div class="title">颜色设置</div>
      <ul class="colors">
        <div v-for="(tem, index) in list" :key="index">
          <div class="title">{{ tem.label }}</div>
          <el-select
            v-model="tem.active.id"
            @change="setColor(tem.active.id, index)"
            placeholder="请选择"
            :style="{backgroundColor: tem.active.color}"
            size="mini"
          >
            <el-option
              v-for="item in colors"
              :key="item.id+ '---' + item.color"
              :label="item.color"
              :value="item.id"
              :style="{backgroundColor: item.color}"
            />
          </el-select>
        </div>
      </ul>
    </div>

    <div class="btn">
      <el-button type="primary" size="medium" @click="handleStyle">确定</el-button>
      <el-button type="info" size="medium" @click="close">取消</el-button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'markingStyle',
  data() {
    return {
      colors: [{
        id: 1,
        prop: 'wdBlack',
        color: 'Black'
      },
      {
        id: 2,
        prop: 'wdBlue',
        color: 'Blue'
      },
      {
        id: 3,
        prop: 'wdTurquoise',
        color: 'Turquoise'
      },
      {
        id: 5,
        prop: 'wdPink',
        color: 'Pink'
      },
      {
        id: 6,
        prop: 'wdRed',
        color: 'Red'
      },
      {
        id: 7,
        prop: 'wdYellow',
        color: 'Yellow'
      },
      {
        id: 8,
        prop: 'wdWhite',
        color: 'white'
      },
      {
        id: 9,
        prop: 'wdDarkBlue',
        color: 'darkblue'
      },
      {
        id: 10,
        prop: 'wdTeal',
        color: 'Teal'
      },
      {
        id: 11,
        prop: 'wdGreen',
        color: 'Green'
      },
      {
        id: 12,
        prop: 'wdViolet',
        color: 'Violet'
      },
      {
        id: 13,
        prop: 'wdDarkRed',
        color: 'DarkRed'
      },
      {
        id: 15,
        prop: 'wdGray50',
        color: '#80808080'
      },
      {
        id: 16,
        prop: 'wdGray25',
        color: '#80808040'
      }],
      radio: 'background',
      list: [{
        label: '错误标记色',
        active: {
          id: 6,
          prop: 'wdRed',
          color: 'Red'
        },
      },
      {
        label: '警告标记色',
        active: {
          id: 7,
          prop: 'wdYellow',
          color: 'Yellow'
        },
      },
      {
        label: '敏感词标记色',
        active: {
          id: 12,
          prop: 'wdViolet',
          color: 'Violet'
        },
      }]
    }
  },
  created() {
    this.$nextTick(() => {
      const textStyle = JSON.parse(localStorage.getItem('textStyle'));
      if(textStyle) {
        const { type, error, warning, sensitive } = textStyle;
        this.radio = type;
        const array = JSON.parse(JSON.stringify(this.colors))
        this.list[0].active = array.find(i => i.id === error);
        this.list[1].active = array.find(i => i.id === warning);
        this.list[2].active = array.find(i => i.id === sensitive);
      }
    })
  },
  methods: {
    handleStyle() {
      localStorage.setItem('textStyle', JSON.stringify(
        {
          type: this.radio,
          error: this.list[0].active.id,
          warning: this.list[1].active.id,
          sensitive: this.list[2].active.id,
        }
      ));
      this.close();
    },
    setColor(val, index) {
      const array = JSON.parse(JSON.stringify(this.colors));
      const active = array.find(i => i.id == val);
      this.list[index].active = active;

    },
    close() {
      window.close();
    },
  }
};
</script>

<style scoped>
.markingStyle {
  padding: 20px;
  box-sizing: border-box;
  height: 100%;
  background-color: #F4F4F4;
}

.item {
  background-color: #fff;
  border-radius: 5px;
  padding: 15px 20px;
  margin: 10px;
}

.title {
  font-size: 16px;
  padding-bottom: 15px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: bold;
}

.colors {
  display: flex;
  font-size: 15px;
  padding: 0;
  justify-content: space-evenly;
  text-align: center;
}

li {
  list-style-type: none;
  text-align: center;
  
}

li>div {
  padding-bottom: 8px;
}

.btn {
  position: absolute;
  bottom: 50px;
  left: 0;
  right: 0;
  text-align: center;
}
::v-deep .el-select {
  margin: 0 20px;
}

::v-deep .el-select input {
  border-radius: 0;
  background-color: transparent;
}
</style>